import {createListenerMiddleware} from "@reduxjs/toolkit";
import type {AnyAction, Dispatch, ListenerEffect} from "@reduxjs/toolkit";

import submitStudentResponseListener from "./chapters/submitStudentResponseListener";
import {submitChapterSession} from "./chapterSessions/submitChapterSession";
import submitChapterSessionListener from "./chapterSessions/submitChapterSessionListener";
import {submitChapterSessionStudentResponse} from "./chapterSessions/submitChapterSessionStudentResponse";
import submitChapterSessionStudentResponseListener from "./chapterSessions/submitChapterSessionStudentResponseListener";
import submitStudentResponse from "./studentResponses/submitStudentResponse";

export const listenerMiddleware = createListenerMiddleware();

type AnyEffect<C extends AnyAction> = ListenerEffect<
	C,
	unknown,
	Dispatch<AnyAction>
>;

listenerMiddleware.startListening({
	actionCreator: submitStudentResponse.fulfilled,
	effect: submitStudentResponseListener as AnyEffect<
		ReturnType<typeof submitStudentResponse.fulfilled>
	>,
});

listenerMiddleware.startListening({
	actionCreator: submitChapterSession.fulfilled,
	effect: submitChapterSessionListener as AnyEffect<
		ReturnType<typeof submitChapterSession.fulfilled>
	>,
});

listenerMiddleware.startListening({
	actionCreator: submitChapterSessionStudentResponse.fulfilled,
	effect: submitChapterSessionStudentResponseListener as AnyEffect<
		ReturnType<typeof submitChapterSessionStudentResponse.fulfilled>
	>,
});

export default listenerMiddleware;
